import { ApiHelper, SortHelper } from '../helpers';
import { useEffect, useState } from 'react';

import Axios from 'axios';
import { CursoSummaryType } from '../types';
import { NivelEnsinoEnum } from '../enums';
import { useTranslation } from 'react-i18next';

const useCursos = (idUnidade: number | null, nivel: string | null) => {
  const { t } = useTranslation();
  const [cursos, setCursos] = useState([]);

  useEffect(() => {
    Axios.get(ApiHelper.getUrl.apiEnsino.cursos(), { params: { nivel: nivel, unidade: idUnidade } }).then((response) =>
      setCursos(
        response.data
          .map((curso: CursoSummaryType) => ({
            label: `${curso.nome}${curso.grau_academico ? ` (${curso.grau_academico.descricao})` : ''}/${curso.unidade.sigla} ${
              curso.municipio ? `- ${curso.municipio.nome}` : ''
            } (${t(NivelEnsinoEnum.findByKey(curso.nivel).descricao).toUpperCase()} - ${curso.modalidade_educacao.descricao})`,
            labelUnidade: `${curso.unidade}`,
            value: curso.id,
          }))
          .sort(SortHelper.sortOptionsFunction),
      ),
    );
  }, [idUnidade, nivel]);

  return cursos;
};

export default useCursos;
